import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Layout } from 'antd'
import { Row, Col } from 'antd'
import 'styleLess/signature/nopermission.scss'
import { getCookie } from 'helper/cookie'
import { InboxOutlined, LockOutlined } from '@ant-design/icons'

import { Helmet } from 'react-helmet'

const ContainerManagement = styled.div``
const Head = styled.div``
const Body = styled.div``

const { Header, Footer, Sider, Content } = Layout
const Container = styled.div`
  // width: 100%;
  // background: #ffffff;
  // padding: 24px;
`
const initalState = {
  data: [],
  isLoading: true,
}

const NoPermission = (props) => {
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const [loadingData, setLoadingData] = useState(true)

  return (
    <ContainerManagement>
      <Helmet>
        <title>AXONS PROJECT | Permission denied</title>
      </Helmet>
      <Head className='management-header nopermission-styles'>
        {/* <h4></h4> */}
        <h1>Permission Denied</h1>
      </Head>
      <Body
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        className='management-body'
      >
        <div className='emytystate'>
          <LockOutlined className='inbox' />
          <h2
            style={{
              color: 'rgba(18, 126, 195, 0.32)',
              fontWeight: 'bold',
              marginTop: 20,
            }}
          >
            No Permission
          </h2>
          <div
            style={{
              maxWidth: 444,
              marginTop: 8,
              padding: '0px 16px 0px 16px',
            }}
          >
            <h4 style={{ textAlign: 'center', color: '#BCBCC4' }}>
              You don’t have permissions to access this page. Contact an administrator to
              get permissions or to go home page and browse other pages
            </h4>
          </div>
        </div>
      </Body>
    </ContainerManagement>
  )
}

export default NoPermission
